// extracted by mini-css-extract-plugin
export default {"cls1":"VeloLabelledItem-LabelledItemContainer_cls1__iB3xR","cls2":"VeloLabelledItem-LabelledItemContainer_cls2__p4iR8 VeloLabelledItem-LabelledItemContainer_cls1__iB3xR"};